var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentCover)?_c('gf-image-cropper',{staticClass:"gf-cropper --cover",attrs:{"selected-image-source":_vm.currentCover,"input-name":"cover","preview-border":"1px","aspect-ratio":17/5,"image-box-width":"600","modal-window-width":"800"},on:{"setDefault":_vm.setDefaultCover}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }